import { useBookingConfig } from 'reservations/account/providers/ConfigProvider';

export function useDefaultPartySize() {
  const { partySizeMin: min, partySizeMax: max } = useBookingConfig();

  // The partySize should be 2 in most cases, but if the partySizeMax
  // is less than 2, then we should respect the partySizeMax.
  // If the partySizeMin happens to be greater than 2, then we should make
  // sure that we use that as the default partySize for looking into the future
  return Math.max(min, Math.min(max, 2));
}
